import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyIndicator',
  standalone: true,
})
export class EmptyIndicatorPipe implements PipeTransform {
  transform<T>(value: T, title?: string): T | string {
    if (!value) {
      return title || '-';
    }
    return value;
  }
}
